/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hide[_ngcontent-%COMP%]{display:none}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
